The candidate's primary email address.

The value must match one of the candidate's email addresses.
Duplicate uploads will result in a `BAD_USER_INPUT` error.

This field has a maximum length of 255 bytes in UTF-8 encoding.
